__turbopack_context__.v({
  "border": "buttonIcon-module__G2XFkW__border",
  "lg": "buttonIcon-module__G2XFkW__lg",
  "md": "buttonIcon-module__G2XFkW__md",
  "noBorder": "buttonIcon-module__G2XFkW__noBorder",
  "root": "buttonIcon-module__G2XFkW__root",
  "sm": "buttonIcon-module__G2XFkW__sm",
});
